<template>
    <div class="dev-milestone-container">
      <h1 class="page-title">Development Milestones</h1>
  
      <!-- Loading / Error States -->
      <div v-if="loading">Loading milestones...</div>
      <div v-else-if="error" class="error-message">{{ error }}</div>
      <div v-else>
        <!-- Timeline: each milestone has a left column with the date and a right card -->
        <div v-for="mile in blogPosts" :key="mile.id" class="timeline-item">
    <!-- Right column: Card with image, title and description -->
          <div class="timeline-card">
            <!-- New headImage: displayed above title -->
            <img v-if="mile.headImage" :src="mile.headImage" alt="Milestone Image" class="milestone-head-image" />
            <h2>{{ mile.title }}</h2>
            <div class="blog-description" v-html="mile.description"></div>
            <div class="timeline-date">
            {{ formatDate(mile.timestamp) }}
          </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import DevMilestoneLogic from "./DevMilestoneLogic.js";
  
  export default {
    name: "DevMilestone",
    mixins: [DevMilestoneLogic],
    methods: {
      formatDate(ts) {
        if (!ts) return "";
        const dateObj = new Date(ts.seconds * 1000);
        return dateObj.toLocaleDateString();
      }
    }
  };
  </script>
  
  <style scoped>
  .dev-milestone-container {
    max-width: 650px;
    margin: 0 auto;
    padding: 1rem;
    font-family: "Poppins", sans-serif;
  }
  
  .page-title {
    font-size: 1.5rem;
    margin-bottom: 1rem;
  }
  
  .error-message {
    color: red;
    margin-top: 1rem;
  }
  
  /* Timeline item container */
  .timeline-item {
    display: flex;
    align-items: flex-start;
   /* margin-bottom: 2rem; */
    position: relative;
  }
  
  /* Left column: date line & dot */
  .timeline-date {
    text-align: left;
    margin-left: 2rem;
    margin-bottom: 1rem;
    color: #999;
  }
  
  /*.timeline-date::after {
    content: "";
    position: absolute;
    left: 115px;
    top: 5px;
    width: 2px;
    height: 100%;
    background-color: #cfcfcf;
    z-index: -1;
  }
  
  .timeline-date::before {
    content: "";
    position: absolute;
    left: 110px;
    top: 5px;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: #EA845A;
  }

  .timeline-item:last-child .timeline-date::after {
  display: none;
}*/
  
  /* Right column: card */
  .timeline-card {
    background-color: #fff;
    border: 1px solid #C9BF9B;
    box-shadow: 0px 4px 3px #dacb9736;
    border-radius: 15px;
    /* padding: 1rem; */
    margin-bottom: 30px;
    flex: 1;
  }
  
  .milestone-head-image {
  width: 100%;
  max-height: 360px; /* Adjust this value as needed */
  border-radius: 15px 15px 0 0;
  object-fit: cover;
}
  
  .timeline-card h2 {
    margin-top: 0;
    margin-bottom: 0.5rem;
    font-size: 1.2rem;
    padding-top: 2rem;
    padding-bottom: 0.5rem;
    padding-left: 2rem;
    padding-right: 2rem;
  }
  .blog-description {
    padding-left: 2rem;
    padding-right: 2rem;
    padding-bottom: 1rem;
  }
  </style>
  